import { render, staticRenderFns } from "./DistribucionFacturas.vue?vue&type=template&id=7fb37c63&scoped=true"
import script from "./DistribucionFacturas.vue?vue&type=script&lang=js"
export * from "./DistribucionFacturas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb37c63",
  null
  
)

export default component.exports